import * as Yup from 'yup'

export const staffLoginSchema = Yup.object().shape({
  user: Yup.string().required('Email or Username Required'),
  password: Yup.string().required('Password Required')
})

export const verificationCodeSchema = Yup.object().shape({
  verificationCode: Yup.string()
    .required('Verification Code Required')
    .min(4, 'Verification code must be at least 4 characters')
    .max(8, 'Verification code must not exceed 8 characters')
})